module.exports = "/static/assets/23ba9e2bbe53a876ed22059ba270c319.png";